import { Dialog, Grid, Link, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { StyledButton } from "../../../common/components/Button";
import { middleEllipsisText } from "../../../common/helpers/middleEllipsisText";
import { API_URL, PROGRESSION_TYPE } from "../../../config";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { CircularProgress } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  DialogHeader,
  FileDetails,
  FilesStack,
  Note,
  SectionTitle,
} from "../styles";

const ViewReviewDialog = ({ caseDetails, open, onClose }) => {
  const [review, setReview] = useState({});
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const reviews = caseDetails.caseProgressions.filter(
      (p) => p.type === PROGRESSION_TYPE.REVIEW_DESIGN
    );

    if (reviews.length > 0) {
      const latestReview = reviews.reduce((prev, current) => {
        if (+current.index > +prev.index) {
          return current;
        } else {
          return prev;
        }
      });
      setReview(latestReview);
    }
  }, [caseDetails]);

  const handleDownloadAll = async () => {
    let zip = new JSZip();
    setIsDownloading(true);
    for (const file of review.files) {
      const response = await fetch(API_URL + `file/${file.id}/download`);
      let blob = await response.blob();
      zip.file(file.fileName, blob);
    }

    zip.generateAsync({ type: "blob" }).then(function (content) {
      saveAs(content, caseDetails.patientName + "_ReviewFiles");
    });
    setIsDownloading(false);
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <Dialog open={isDownloading}>
        <Box sx={{ paddingX: 10, paddingY: 10 }}>
          <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
          <Typography sx={{ marginTop: 4, color: grey[600] }}>
            Please wait while we process your request.
          </Typography>
        </Box>
      </Dialog>
      <Box sx={{ paddingX: 3, paddingY: 2 }}>
        <DialogHeader>
          {review.isApproved ? "Design Approved" : "Design Rejected"}
        </DialogHeader>
        <br />
        {review.files && review.files.length > 0 && (
          <Box sx={{ marginBottom: 2, marginTop: 2 }}>
            <StyledButton theme="green" onClick={handleDownloadAll}>
              Download All Files
            </StyledButton>
            <FilesStack
              direction="row"
              spacing={1}
              style={{ overflowX: "scroll", WebkitOverflowScrolling: "touch" }}
            >
              {review.files &&
                review.files.map((file) => (
                  <FileDetails>
                    <Typography>{middleEllipsisText(file.fileName)}</Typography>
                    <Link
                      href={API_URL + `file/${file.id}/download`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download
                    </Link>
                  </FileDetails>
                ))}
            </FilesStack>
          </Box>
        )}

        <Grid rowSpacing={2} container>
          <Grid item xs={1}>
            <SectionTitle>Note</SectionTitle>
          </Grid>
          <Grid item xs={11}>
            <Note>{review.note}</Note>
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", marginTop: 2 }}>
          <Box sx={{ marginLeft: "auto" }}>
            <StyledButton theme="green" onClick={onClose}>
              Close
            </StyledButton>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ViewReviewDialog;
